<template>
  <v-container>
    <products
      :options="product"
      :tags="tags"
      :small="small"
    />
  </v-container>
</template>

<script>
import Products from './Products'

export default {
  components:{
    Products,
  },
  props: {
    tags: {
      type: Array,
      default: ()=>[]
    },
    product: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    small: {
      type: Boolean
    }
  },
}
</script>